import { TimeSwitch } from "src/utils/fw"
import { isMember, leaderboardOptIn } from "../utils"
import { auditoriumCloseDate } from "../utils"
import { useState } from "preact/hooks"
import HTEP from "../rooms/modals/HTEP"
import { onDemandDate } from "../spa"

export const Navbar = () => {
	const [open, setOp] = useState(false)

	return <div class="venue-navbar-wrapper">
		<div class="topnavtk2 left-nav" id="myTopnavtk2">
			<a href="https://isfcongress.tkeventsregistration.com/2024" id="LeaveEvent" class="activetk2">Leave Event</a>
			{
				false && <div class="dropdowntk2">
					<button class="dropbtntk2">Schedule
						<i class="fa fa-caret-down" />
					</button>
					<div class="dropdown-contenttk2">
						<a href="https://isfcongress.tkeventsregistration.com/2024/agendavirtual" title="Full Schedule" target="_blank">Full Schedule</a>
						<a href="https://isfcongress.tkeventsregistration.com/2024/personalagendareg" title="Personal Agenda" target="_blank">Personal Agenda</a>
					</div>
				</div>
			}
			<a href="/atrium">Atrium</a>
			<div class="dropdowntk2">
				<button class="dropbtntk2">Room Navigation
					<i class="fa fa-caret-down" />
				</button>
				<div class="dropdown-contenttk2">
					<a href="/atrium" title="Atrium">Atrium</a>
					<TimeSwitch>
						{[
							{
								starts: new Date("2023-10-22 08:00:00+0200"),
								ends: auditoriumCloseDate,
								content: <>
									{isMember && <a href="/auditorium" title="Auditorium 1">Auditorium 1</a>} 
									{isMember && <a href="/auditorium-two" title="Auditorium 2">Auditorium 2</a>}
								</>
							},
							{
								starts: auditoriumCloseDate,
								ends: new Date("2024-10-24 14:00:00+0200"),
								content: <></>
							}
						]}
					</TimeSwitch>
					<a href="/exhibition-hall" title="Exhibition Hall">Exhibition</a>
					{isMember && <a href="/exploration-zone" title="ISF Exploration Zone">ISF Exploration Zone</a>}
					{isMember && new Date() > onDemandDate && <a href="/on-demand" title="on-demand">On Demand</a>}

				</div>
			</div>
			{ 
				isMember && <div class="dropdowntk2">
					<button class="dropbtntk2">Directories
							<i class="fa fa-caret-down" />
					</button>
					<div class="dropdown-contenttk2">
						<a href="https://isfcongress.tkeventsregistration.com/2024/attendeedirectoryvirtual" title="Attendee Directory" target="_blank">Attendee Directory</a>
						<a href="https://isfcongress.tkeventsregistration.com/2024/speakerdirectoryvirtual" title="Speaker Directory" target="_blank">Speaker Directory</a>
						<a href="https://isfcongress.tkeventsregistration.com/2024/sponsordirectory" title="Sponsor Directory" target="_blank">Sponsor Directory</a>
					</div>
				</div>
			}
			{false && <a id="how-to-earn" style={{cursor: "pointer", whiteSpace: "nowrap"}} title="How to Earn Leaderboard Points" onClick={() => {
						setOp(true)
				}}>How to Earn Leaderboard Points</a>}
			<HTEP open={open} onChange={(op) => {
			if (op !== open) setOp(op)
		}}/>
		</div>
	</div>
}